import styled from "styled-components/macro"
import QuickAdd from "components/Ui/Table/QuickAdd"
import PrimaryButton from "components/Ui/Buttons/PrimaryButton"
import TableRowSimple from "components/Ui/Table/TableRowSimple"
import TableHeader from "components/Ui/Table/TableHeader"
import SingleSelect from "components/Ui/Form/SingleSelect"

type StyledProps = {
  $active: boolean
}

export const Container = styled.div`
  margin-right: 0;
  padding-bottom: 1rem;

  > div {
    display: block;
  }
`

export const Add = styled(QuickAdd)`
  background: transparent;
  border-top: 0.1rem solid ${(p) => p.theme.colors.greyLight};
  border-bottom: 0.1rem solid ${(p) => p.theme.colors.greyLight};
  padding: 2rem 0;
`

export const AddButton = styled(PrimaryButton)`
  margin: -3rem 0 0 auto;
`

export const Thresholds = styled.div`
  width: 100%;

  p {
    text-align: center;
  }
`

export const TresholdHeader = styled(TableHeader)`
  padding: 0 6rem 0 2rem;
`

export const ThresholdRow = styled(TableRowSimple)`
  background: rgba(255, 255, 255, 0.5);
  padding: 1.2rem 2rem 1rem;
  margin-bottom: rem;
`

export const TresholdCell = styled.div`
  display: flex;
  justify-content: center;
  flex-direction: column;
  flex: 1;
  font-size: 1.1rem;
  line-height: 1.7rem;
  padding-right: 1rem;

  span {
    line-height: 1.8rem;
    font-size: 1.4rem;
    ${(p) => p.theme.bold}
  }
`

export const Currency = styled(TresholdCell)`
  width: 50%;
  flex: auto;
`

export const Amount = styled(TresholdCell)`
  flex: auto;
  width: calc(50% - 8rem);
`
export const PriceRuleContainer = styled.div`
  display: flex;
  flex-direction: column;
  margin-top: 1.5rem;
`

export const TypeSelectorContainer = styled.div`
  width: 100%;
  display: grid;
  gap: 2rem;
  margin-bottom: 2rem;
  grid-template-columns: repeat(1, 1fr);

  ${(p) => p.theme.mQ.MEDIA_MIN_MEDIUM} {
    grid-template-columns: repeat(3, 1fr);
    gap: 4rem;
    flex-direction: row;
    justify-content: flex-start;
  }
`

export const InputWrapper = styled.div`
  display: grid;
  gap: 2rem;
  grid-template-columns: 3fr 3fr 1fr;
  button {
    margin: 0;
    position: relative;
    top: 2.8rem;
    height: 4.5rem;
  }
`

export const TypeSelector = styled.div<StyledProps>`
  background: ${(p) => (p.$active ? p.theme.colors.turquoiseDark : p.theme.colors.white)};
  color: ${(p) => (p.$active ? p.theme.colors.white : p.theme.colors.black)};
  width: 100%;
  border: 0.1rem solid ${(p) => p.theme.colors.greyLight};
  border-radius: 0.6rem;
  padding: 1.5rem 0;
  cursor: pointer;
  text-align: center;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;

  svg {
    margin-bottom: 0.3rem;
    width: 3rem;
    height: 3rem;
    fill: ${(p) => (p.$active ? p.theme.colors.white : p.theme.colors.black)};
  }
`

export const CurrencySelect = styled(SingleSelect)`
  margin-bottom: 1rem;
`

export const Formatted = styled.div`
  margin: 1rem 0;
`
export const Description = styled.span`
  font-size: 1.4rem;
  color: ${(p) => p.theme.colors.greyDarker};
  margin-bottom: 1.5rem;
`
